var map = {
	"./account-footer.jpg": 769,
	"./account_no bg.png": 6122,
	"./agent-chat-ava-1.png": 1123,
	"./agent-chat-ava-2.png": 4264,
	"./app-store.png": 2277,
	"./availability.png": 2303,
	"./availability_bg.png": 9301,
	"./avatar-agent.png": 1361,
	"./avatar-agent@2x.png": 9987,
	"./avatar-attention@2x.png": 3448,
	"./avatar-cripto.png": 3019,
	"./avatar-cripto@2x.png": 1333,
	"./avatar-mpesa-agent.png": 6554,
	"./avatar-mpesa-agent@2x.png": 2442,
	"./avatar-mpesa.png": 7294,
	"./avatar-mpesa@2x.png": 2518,
	"./avatar-pesa-agent.png": 2929,
	"./avatar-pesa-agent@2x.png": 1939,
	"./avatar-pesa-ref.png": 1373,
	"./avatar-pesa-ref@2x.png": 4071,
	"./avatar.png": 8525,
	"./bannerInvite_bg.png": 6577,
	"./bg_banner_indentify.jpg": 4047,
	"./currency-pesa.png": 7443,
	"./currency-pesa@2x.png": 6221,
	"./currency-ssp.png": 3174,
	"./currency-usd.png": 4360,
	"./currency-usd@2x.png": 736,
	"./deposit-to-pesa.png": 1452,
	"./deposit-to-ssp.png": 4851,
	"./google-play.png": 7088,
	"./icon-account-no-bg.png": 371,
	"./icon-availability.png": 2241,
	"./icon-faq.png": 4658,
	"./icon-reward-no-bg.png": 8209,
	"./icon-reward.png": 3005,
	"./image_2.png": 6404,
	"./invite.jpg": 7289,
	"./iphone-1.png": 3395,
	"./iphone-2.png": 8904,
	"./log_out_default.jpg": 9025,
	"./pesa-purchase-error.png": 6978,
	"./pesa-purchase.png": 6967,
	"./popup-cancel.png": 4699,
	"./qr-code.svg": 8941,
	"./rewards.png": 3548,
	"./rewards_banner_info.jpg": 6908,
	"./send-avatar.png": 6592,
	"./send-cancel.png": 6869,
	"./send-fail.png": 2751,
	"./send-pesa-agent.png": 8434,
	"./send-pesa.png": 4870,
	"./send-success.png": 8538,
	"./still_here.jpg": 1865,
	"./verify_icon.png": 9677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2744;